<template>
  <div :class="$style['language-switch']">
    <v-menu
      offset-y
      auto
      max-height="300px"
      :content-class="$style.menu"
      :z-index="highZIndex ? 999999991 : 1000"
    >
      <template #activator="{ on }">
        <div v-on="on">
          <BaseButton :class="$style.button" type="black" small>
            <IconSelect :icon="currentLanguage.flag" width="40" height="40" />
          </BaseButton>
        </div>
      </template>

      <v-list dense flat tile>
        <v-list-item-group>
          <template v-for="(lang, index) in languages">
            <!-- V-IF und template-Tag nur vorläufig, um Polnisch auszublenden! -->
            <v-list-item
              v-show="lang.show"
              :key="index"
              :ripple="false"
              :class="[
                $style['list-item'],
                { 'current-language': lang.code === currentLanguageCode },
              ]"
              :href="`${lang.url}#${$route.fullPath}`"
            >
              <v-list-item-icon>
                <IconSelect :icon="lang.flag" width="25" height="25" />
              </v-list-item-icon>
              <!-- <v-list-item-content>
                {{ $t(`settings.language.${lang.code}`) }}
              </v-list-item-content> -->
            </v-list-item>
          </template>
        </v-list-item-group>
        <LanguageSwitchToKeys />
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { get, has } from 'lodash-es'

import { mapGetters } from 'vuex'

import { toUpperCase } from '@/js/filters/text-filters.js'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'

import { LanguageSwitchToKeys } from '@/js/components/Navigation/utils/language-keys-component'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'NavigationLanguageSwitch',
  components: { LanguageSwitchToKeys, IconSelect },
  filters: {
    toUpperCase,
  },
  props: {
    highZIndex: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      storedLanguages: APP_GETTER.LANGUAGES,
    }),
    currentLanguage() {
      return this.languages.find(lang => lang.current === true)
    },
    currentLanguageCode() {
      return get(this.currentLanguage, 'code')
    },

    storedLanguagesWithFlags() {
      const countryFlag = {
        en: 'CountryFlagUnitedKingdom',
        de: 'CountryFlagGermany',
        fr: 'CountryFlagFrance',
        es: 'CountryFlagSpain',
        nl: 'CountryFlagNetherlands',
        pl: 'CountryFlagPoland',
        cs: 'CountryFlagCzech',
      }

      const visibleLanguages = ['en', 'de', 'nl', 'fr', 'es', 'pl', 'cs']

      console.log('🚀 ~ storedLanguagesWithFlags ~ visibleLanguages:', visibleLanguages)

      return this.storedLanguages
        .filter(l => has(countryFlag, l.code))
        .map(l => ({ ...l, flag: countryFlag[l.code], show: visibleLanguages.includes(l.code) }))
    },

    languages() {
      const languageTranslationKey = 'app.languageOrder'
      const languageTranslation = this.$t(languageTranslationKey)
      const languageOrder = (
        languageTranslation === languageTranslationKey
          ? ['en', 'de', 'nl', 'fr', 'es', 'pl', 'cs']
          : languageTranslation.split(',').map(lang => lang.trim())
      ).filter(l => has(this.storedLanguagesWithFlags, l))

      return [...this.storedLanguagesWithFlags].sort((a, b) =>
        languageOrder.indexOf(a.code) === -1
          ? 1
          : languageOrder.indexOf(b.code) === -1
          ? -1
          : languageOrder.indexOf(a.code) - languageOrder.indexOf(b.code),
      )
    },
  },
}
</script>

<style lang="scss" module>
.button {
  width: fit-content !important;
  min-width: fit-content !important;
  height: fit-content !important;
  padding: 0 !important;
}

.lang {
  font-weight: var(--font-weight-normal);

  font-size: var(--font-xs);
  line-height: 1;
}

.language-switch {
  display: flex;
  justify-content: center;
  width: 3.5rem;
  min-width: 3.5rem;

  :global(.btn.v-btn) {
    border: none !important;
  }

  :global(.theme--light.v-btn.v-btn--has-bg) {
    background-color: transparent !important;
  }

  :global(.btn.v-btn.btn--border-black:hover) {
    box-shadow: none !important;
  }
}

:global(.v-application .v-menu__content).menu {
  max-height: 18rem !important;
}

.menu {
  min-width: 50px !important;
  max-height: 18rem !important;
  margin-top: 0.75rem;
}

.list-item {
  min-height: 2.375rem;

  color: var(--black) !important;
  text-align: center;

  border-radius: 999px;

  transition: all 280ms;

  :global(.v-list-item__icon) {
    margin-right: 0 !important;
  }
}

a.list-item {
  margin: 2px 8px;

  text-decoration: none;

  &:hover {
    text-decoration: none;

    :global(.v-list-item__icon) {
      border-radius: 50%;
      box-shadow: 0 0 0 4px var(--primary) !important;
    }
    // box-shadow: 0 0 0 2px currentColor !important;
  }
}

.list-title {
  font-weight: var(--font-weight-medium);
  font-size: var(--font-xs);
}

:global(.v-item-group .current-language) {
  // margin: 2px 6px;

  :global(.v-list-item__icon) {
    margin-right: 0 !important;

    border-radius: 50%;

    box-shadow: 0 0 0 4px var(--primary) !important;
  }

  // color: var(--primary) !important;

  // border: 2px solid;
  // border-color: currentColor;
  // border-radius: 999px;
}
</style>
